import type { MouseEventHandler } from 'react';

import { EventType } from '@/analytics/types';
import FooterCta from '@/app/components/FooterCta';

const HowItWorksFooterCta = (): JSX.Element => {
  const handleLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;
    const url = new URL(href);
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      action: 'go_to_pdp',
      cta: 'shop_now',
      location: 'body',
      path: url.pathname,
    });
  };

  return (
    <FooterCta
      button={{
        href: '/product/rings',
        label: 'how_it_works_become_a_member_cta',
        onClick: handleLinkClick,
        variant: 'secondary-light',
      }}
      className="relative bg-slate-600 py-8 text-sandstone-200 lg:py-16"
      description="how_it_works_become_a_member_copy"
      image={{ src: 'blue-sky/how-it-works/become-a-member.jpg?exp=-7' }}
      title="how_it_works_become_a_member_title"
      variant={{ sm: 'two_column', lg: 'background' }}
    />
  );
};

export default HowItWorksFooterCta;
